"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-DashSmall" },
      _react2.default.createElement("path", { d: "M8 4H2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M10.99 5H1.01a1 1 0 0 0 0 2h9.98a1 1 0 1 0 0-2z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'DashSmall';
exports.default = WrappedIcon;

